var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"banner"},[_vm._v(" Logged in as Customer Support."),_c('br'),_vm._v(" Viewing as: "),_c('strong',[_vm._v(_vm._s(_vm.username))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }